module.exports = __webpack_public_path__ + "static/media/window-restore.687a18c6.svg";